/** Ordens do seletor "Ordenar por" da fila (RDN-49). */
export type OrdemDaFila = 'atual' | 'antigas' | 'recentes' | 'nome';

export const OPCOES_DE_ORDEM: { valor: OrdemDaFila; rotulo: string }[] = [
  { valor: 'atual', rotulo: 'Ordem atual' },
  { valor: 'antigas', rotulo: 'Cadastro mais antigo' },
  { valor: 'recentes', rotulo: 'Cadastro mais recente' },
  { valor: 'nome', rotulo: 'Nome da realização' },
];

interface RealizacaoOrdenavel {
  created?: number;
  title?: string;
}

const COMPARADORES: Record<Exclude<OrdemDaFila, 'atual'>, (a: RealizacaoOrdenavel, b: RealizacaoOrdenavel) => number> = {
  antigas: (a, b) => (a.created ?? 0) - (b.created ?? 0),
  recentes: (a, b) => (b.created ?? 0) - (a.created ?? 0),
  nome: (a, b) => (a.title ?? '').localeCompare(b.title ?? '', 'pt-BR'),
};

/**
 * Ordena a fila sem alterar a lista recebida (RDN-49). "Ordem atual" devolve a ordem do aggregate; nas demais,
 * empates mantêm a ordem recebida (`Array.prototype.sort` é estável).
 */
export function ordenarFila<T extends RealizacaoOrdenavel>(tarefas: T[], ordem: OrdemDaFila): T[] {
  const copia = [...tarefas];
  return ordem === 'atual' ? copia : copia.sort(COMPARADORES[ordem]);
}
